<template>
    <tr
        class="kgr-table__row"
    >
        <td
            v-if="isBulkInvoiceOperation"
            class="kgr-table__cell"
        >
        </td>
        <td class="kgr-table__cell">
        </td>
        <td
            class="kgr-table__cell"
        >
            <kgr-icon
                style="margin-bottom: -5px; margin-left: 15px;"
                icon-class="arrow-forward"
                disabled
                small
            />
            {{ label }}
            <span style="color:red;">{{ formatMoney }}</span>
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
        </td>
        <td class="kgr-table__cell">
            {{ formatAppliedAt }} {{ dunningStatusMessage }}
        </td>
        <td class="kgr-table__cell">
            <span style="float:right">
                <kgr-invoice-dunning-pdf-button
                    :invoice="invoice"
                    :dunning-level="dunningLevel"
                    @reloadInvoice="$emit('reloadInvoice')"
                />
                <kgr-invoice-dunning-email-button
                    :invoice="invoice"
                    :dunning-level="dunningLevel"
                    @sendDunning="$emit('sendDunning')"
                />
            </span>
        </td>
    </tr>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';
import InvoiceDunningEmailButton from './InvoiceDunningEmailButton';
import InvoiceDunningPdfButton from './InvoiceDunningPdfButton';
import Money from '../../../js/dto/Money.js';

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-invoice-dunning-pdf-button': InvoiceDunningPdfButton,
        'kgr-invoice-dunning-email-button': InvoiceDunningEmailButton,
    },
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
        dunningLevel: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isBulkInvoiceOperation:{
            type: Boolean,
            required: false,
            default:false
        }
    },
    data() {
        return {
            helper: new Helper(),
        }
    },
    computed: {
        formatAppliedAt() {
            return this.$t('Erstellt:') + ' ' + this.helper.formatDate(this.invoice.dunningStatusHistory[this.dunningLevel]);
        },
        dunningStatusMessage() {
            if (this.dunningLevel === this.invoice.dunningStatus.status && null !== this.invoice.dunningStatusMessage) {
                return ' (' + this.invoice.dunningStatusMessage + ')'
            }
            return '';
        },
        formatMoney() {
            if (null !== this.invoice.dunningAmount && this.dunningLevel === this.invoice.dunningStatus.status) {
                return ' (' + Money.fromData(this.invoice.dunningAmount).toLocalizedString()
                    + ' ' + this.invoice.dunningAmount.currency
                    + ' - ' + this.invoice.dunningFee + ')';
            }
            return '';
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
